import { render, staticRenderFns } from "./index.vue?vue&type=template&id=519c92fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519c92fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('519c92fe')) {
      api.createRecord('519c92fe', component.options)
    } else {
      api.reload('519c92fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=519c92fe&scoped=true", function () {
      api.rerender('519c92fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Operations/staffAuthorityManage/index.vue"
export default component.exports